import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getBloqueios as getBloqueiosSdk,
  postBloqueio as postBloqueioSdk,
  deleteBloqueio as deleteBloqueioSdk,
} from '@sdk/Conectores/Bloqueios';

//Action Types
export const Types = {
  GET_BLOQUEIOS: 'GET_BLOQUEIOS',
  GET_BLOQUEIOS_SUCCESS: 'GET_BLOQUEIOS_SUCCESS',
  GET_BLOQUEIOS_ERROR: 'GET_BLOQUEIOS_ERROR',

  POST_BLOQUEIO: 'POST_BLOQUEIO',
  POST_BLOQUEIO_SUCCESS: 'POST_BLOQUEIO_SUCCESS',
  POST_BLOQUEIO_ERROR: 'POST_BLOQUEIO_ERROR',

  DELETE_BLOQUEIO: 'DELETE_BLOQUEIO',
  DELETE_BLOQUEIO_SUCCESS: 'DELETE_BLOQUEIO_SUCCESS',
  DELETE_BLOQUEIO_ERROR: 'DELETE_BLOQUEIO_ERROR',

  RESET_BLOQUEIOS: 'RESET_BLOQUEIOS',
};

//Action Creators
export const getBloqueios = () => ({ type: Types.GET_BLOQUEIOS });
export const getBloqueiosSuccess = (data) => ({ type: Types.GET_BLOQUEIOS_SUCCESS, data });
export const getBloqueiosError = (error) => ({ type: Types.GET_BLOQUEIOS_ERROR, error });

export const postBloqueio = (data) => ({ type: Types.POST_BLOQUEIO, data });
export const postBloqueioSuccess = () => ({ type: Types.POST_BLOQUEIO_SUCCESS });
export const postBloqueioError = (error) => ({ type: Types.POST_BLOQUEIO_ERROR, error });

export const deleteBloqueio = (conectorIdentify) => ({ type: Types.DELETE_BLOQUEIO, conectorIdentify });
export const deleteBloqueioSuccess = () => ({ type: Types.DELETE_BLOQUEIO_SUCCESS });
export const deleteBloqueioError = (error) => ({ type: Types.DELETE_BLOQUEIO_ERROR, error });

export const reset = () => ({ type: Types.RESET_BLOQUEIOS });

//saga
function* fetchGetBloqueios(action) {
  try {
    const bloqueios = yield call(getBloqueiosSdk);
    yield put(getBloqueiosSuccess(bloqueios));
  } catch (err) {
    Notification.error(err.message);
    yield put(getBloqueiosError(err));
  }
}

function* fetchPostBloqueio(action) {
  try {
    yield call(postBloqueioSdk, action.data);
    yield put(postBloqueioSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postBloqueioError(err));
  }
}

function* fetchDeleteBloqueio(action) {
  try {
    const { conectorIdentify } = action;
    yield call(deleteBloqueioSdk, conectorIdentify);
    yield put(deleteBloqueioSuccess());
    Notification.success('Conector desbloqueado');
  } catch (err) {
    Notification.error(err.message);
    yield put(deleteBloqueioError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_BLOQUEIOS, fetchGetBloqueios),
  takeLatest(Types.POST_BLOQUEIO, fetchPostBloqueio),
  takeLatest(Types.DELETE_BLOQUEIO, fetchDeleteBloqueio),
];

// Reducer
const initialState = Map({
  bloqueios: List(),

  loadingBloqueios: false,
  successBloqueios: false,
  errorBloqueios: false,

  postingBloqueio: false,
  successPostBloqueio: false,
  errorPostBloqueio: false,

  deletingBloqueio: false,
  successDeleteBloqueio: false,
  errorDeleteBloqueio: false,
});

const handleGetBloqueios = (state, action) => {
  return state.set('loadingBloqueios', true).set('successBloqueios', false).set('errorBloqueios', false);
};

const handleGetBloqueiosSuccess = (state, action) => {
  const bloqueios = action.data;
  return state.set('bloqueios', List(bloqueios)).set('loadingBloqueios', false).set('successBloqueios', true).set('errorBloqueios', false);
};

const handleGetBloqueiosError = (state, action) => {
  return state.set('loadingBloqueios', false).set('successBloqueios', false).set('errorBloqueios', action.error);
};

const handlePostBloqueio = (state, action) => {
  return state.set('postingBloqueio', true).set('successPostBloqueio', false).set('errorPostBloqueio', false);
};

const handlePostBloqueioSuccess = (state, action) => {
  return state.set('posttingBloqueio', false).set('successPostBloqueio', true).set('errorPostBloqueio', false);
};

const handlePostBloqueioError = (state, action) => {
  return state.set('posttingBloqueio', false).set('successPostBloqueio', false).set('errorPostBloqueio', action.error);
};

const handleDeleteBloqueio = (state, action) => {
  return state.set('deletingBloqueio', true).set('successDeleteBloqueio', false).set('errorDeleteBloqueio', false);
};

const handleDeleteBloqueioSuccess = (state, action) => {
  return state.set('deletingBloqueio', false).set('successDeleteBloqueio', true).set('errorDeleteBloqueio', false);
};

const handleDeleteBloqueioError = (state, action) => {
  return state.set('deletingBloqueio', false).set('successDeleteBloqueio', false).set('errorDeleteBloqueio', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_BLOQUEIOS:
      return handleGetBloqueios(state, action);
    case Types.GET_BLOQUEIOS_SUCCESS:
      return handleGetBloqueiosSuccess(state, action);
    case Types.GET_BLOQUEIOS_ERROR:
      return handleGetBloqueiosError(state, action);

    case Types.POST_BLOQUEIO:
      return handlePostBloqueio(state, action);
    case Types.POST_BLOQUEIO_SUCCESS:
      return handlePostBloqueioSuccess(state, action);
    case Types.POST_BLOQUEIO_ERROR:
      return handlePostBloqueioError(state, action);

    case Types.DELETE_BLOQUEIO:
      return handleDeleteBloqueio(state, action);
    case Types.DELETE_BLOQUEIO_SUCCESS:
      return handleDeleteBloqueioSuccess(state, action);
    case Types.DELETE_BLOQUEIO_ERROR:
      return handleDeleteBloqueioError(state, action);

    case Types.RESET_BLOQUEIOS:
      return handleReset(state, action);

    default:
      return state;
  }
}
